import { useEffect, memo } from 'react';
import I18n from 'I18n';
import { NavMarker } from 'react-rhumb';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { EmptyState as FoundationsEmptyState } from 'foundations-components/transitional/components/EmptyState';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Link } from 'foundations-components/transitional/components/Link';
import { trackScreen } from 'FormsUI/utils/TrackingUtils';
import getKnowledgeUrl from 'forms-utils-lib/urls/app/getKnowledgeUrl';
import FreeStarterEmptyState from 'FormsUI/components/dashboard/zeroState/freeStarter/EmptyState';
import useShowFreeStarterEmptyState from 'FormsUI/components/hooks/zeroState/useShowFreeStarterEmptyState';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LearnMoreLink = () => /*#__PURE__*/_jsx(Link, {
  href: `${getKnowledgeUrl()}/articles/kcs_article/forms/create-forms`,
  external: true,
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "dashboard.zeroState.learnMore"
  })
});
const PrimaryContent = () => /*#__PURE__*/_jsxs("div", {
  children: [/*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "dashboard.zeroState.introductionBodyWithPopups"
    })
  }), /*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "dashboard.zeroState.introductionCta",
      options: {
        learnMoreLink: /*#__PURE__*/_jsx(LearnMoreLink, {})
      }
    })
  })]
});
const EmptyState = /*#__PURE__*/memo(() => /*#__PURE__*/_jsx(NavMarker, {
  name: "FORMS_DASHBOARD_ZERO_STATE",
  children: /*#__PURE__*/_jsx(FoundationsEmptyState, {
    id: "forms-dashboard-zero-state",
    titleText: I18n.text('dashboard.zeroState.introductionTitle'),
    primaryContent: /*#__PURE__*/_jsx(PrimaryContent, {}),
    secondaryContent: /*#__PURE__*/_jsx(Illustration, {
      width: "100%",
      name: "forms"
    }),
    secondaryContentWidth: 200
  })
}));
const ZeroState = () => {
  useEffect(() => {
    trackScreen('dashboard', 'zero-state');
    return () => {
      trackScreen('dashboard');
    };
  }, []);
  const showFreeStarterEmptyState = useShowFreeStarterEmptyState(true);
  if (showFreeStarterEmptyState) {
    return /*#__PURE__*/_jsx(FreeStarterEmptyState, {});
  }
  return /*#__PURE__*/_jsx(EmptyState, {});
};
export default ZeroState;